import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-fullscreen-gallery',
  templateUrl: './fullscreen-gallery.component.html',
  styleUrls: ['./fullscreen-gallery.component.scss']
})
export class FullscreenGalleryComponent implements OnInit {

  @Input() images: Array<string> = [];
  @Input() position: number = 0;
  @Output() onClose = new EventEmitter();

  // Change image with arrow keys, close with escape
  @HostListener('document:keydown', ['$event'])
  onPress(e: KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();
    if(e.key == "ArrowRight" || e.key == "ArrowDown") {
      this.next();
    }
    else if(e.key == "ArrowLeft" || e.key == "ArrowUp") {
      this.previous();
    }
    else if(e.key == "Escape") {
      this.close();
    }
    
  }

  constructor() { }

  ngOnInit() {
  }

  previous() {
    this.position--;
    let length = this.images.length;
    this.position = ((this.position%length)+length)%length;
  }

  next() {
    this.position++;
    let length = this.images.length;
    this.position = ((this.position%length)+length)%length;
  }

  close() {
    this.onClose.emit();
  }

}
